// extracted by mini-css-extract-plugin
export default {"maindiv":"Footer_maindiv__RH0a7","innerdiv":"Footer_innerdiv__SrT5M"};